import { render, staticRenderFns } from "./FirmFilesUpload.vue?vue&type=template&id=1ba91c1c"
import script from "./FirmFilesUpload.vue?vue&type=script&lang=js"
export * from "./FirmFilesUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports